import Joi from "joi";

const checkoutSchema = Joi.object()
  .keys({
    company: Joi.string().min(2).max(500).required(),
    contact: Joi.string().min(2).max(500).required(),
    phone: Joi.string().min(2).max(20).required(),
    country: Joi.string().min(2).max(500).required(),
    "line-1": Joi.string().min(1).max(500).required(),
    city: Joi.string().min(3).max(500).required(),
    postcode: Joi.string().min(1).max(20).required(),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required(),
  })
  .unknown(true);

const eventSchema = {
  0: Joi.object()
    .keys({
      company: Joi.string().min(2).max(500).required(),
      contact: Joi.string().min(2).max(500).required(),
      "main-email": Joi.string().required(),
      country: Joi.string().min(3).max(500).required(),
      "line-1": Joi.string().min(1).max(500).required(),
      city: Joi.string().min(3).max(500).required(),
    })
    .unknown(true),
  1: Joi.object()
    .keys({
      delegates: Joi.array()
        .items({
          name: Joi.string().required(),
          phone: Joi.string().required(),
          ticket: Joi.string().required(),
        })
        .options({ allowUnknown: true })
        .min(1),
    })
    .unknown(true),
};

const warrantyRegistrationSchema = {
  0: Joi.object()
    .keys({
      "supplied-by": Joi.string().min(2).max(500).required(),
      products: Joi.array()
        .items({
          type: Joi.string().required(),
          model: Joi.string().required(),
          serial: Joi.string().required(),
          // engine: Joi.string().required(),
          supplied: Joi.date().required(),
        })
        .options({ allowUnknown: true })
        .min(1),
    })
    .unknown(true),
  1: Joi.object()
    .keys({
      firstname: Joi.string().min(1).max(500).required(),
      lastname: Joi.string().min(1).max(500).required(),
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: false })
        .required(),
      phone: Joi.string().min(3).max(250).required(),
      country: Joi.string().min(3).max(500).required(),
      "line-1": Joi.string().min(1).max(500).required(),
      city: Joi.string().min(3).max(500).required(),
    })
    .unknown(true),
};

const brochureRequestSchema = {
  0: Joi.object()
    .keys({
      firstname: Joi.string().min(1).max(500).required(),
      lastname: Joi.string().min(1).max(500).required(),
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: false })
        .required(),
      phone: Joi.string().min(3).max(250).required(),
      company: Joi.string().min(3).max(500).required(),
      country: Joi.string().min(3).max(500).required(),
      "line-1": Joi.string().min(1).max(500).required(),
      city: Joi.string().min(3).max(500).required(),
    })
    .unknown(true),
  1: Joi.object()
    .keys({
      comment: Joi.string().min(0).max(2500),
      productsOfInterest: Joi.array().min(1),
    })
    .unknown(true),
};

export {
  warrantyRegistrationSchema,
  brochureRequestSchema,
  eventSchema,
  checkoutSchema,
};
